export function getGuestSummaryString(
  adults: number | null,
  children: number | null,
  guests?: number
) {
  if (!adults && !children && guests) return `${guests} Guest${guests > 1 ? 's' : ''}`;
  if (adults && !children) return `${adults} Adult${adults > 1 ? 's' : ''}`;
  if (adults && children)
    return `${adults} Adult${adults > 1 ? 's' : ''}, ${children} ${
      children > 1 ? 'Children' : 'Child'
    }`;
  return '';
}
